import React from "react";
import { CloseIcon } from "../../Assets/assets";
import Modal from "../Modal/Modal";
import "./SideBar.css";

export default function SideBar(props) {
  return (
    <div style={{ minWidth: "360px", width: "25%" }}>
      <Modal
        show={true}
        canIgnore={true}
        transparentBackgroundColor={true}
        onClose={() => {
          props.navigate(-1);
        }}
        height="inherit-parent-height"
        width="width-360px"
        minWidth="none"
        borderRadius="none"
        background="background-color-tertiaryColor2"
        position="position-absolute bottom-0 right-0"
      >
        <div className="">
          <div className="display-flex flex-justify-content-space-between flex-align-items-center padding-large">
            <div className="font-color-tertiaryColor font-size-larger">
              {props.title}
            </div>
            <div
              onClick={() => {
                props.navigate(-1);
              }}
              style={{
                height: "16px",
                width: "16px"
              }}
              className="cursor-pointer"
            >
              <CloseIcon color="var(--tertiaryColor6)" />
            </div>
          </div>
          {props.children || <div></div>}
        </div>
      </Modal>
    </div>
  );
}
